export const FOOTER_NAV_LINKS = [
    { label: 'الرئيسية', route: 'welcome' },
    { label: 'حساب جديد', route: 'register' },
    { label: 'تسجيل دخول', route: 'login' },
    { label: 'عن المنصة', route: 'about' },
    { label: 'الدعم الفني', route: 'help' },
    { label: 'سياسة الخصوصية', route: 'privacy-policy' },
    { label: 'شروط الاستخدام', route: 'terms' },
    { label: 'الكورسات', route: 'courses' },
];

const SOCIAL_FIELDS = [
    { key: 'youtube_url', brand: 'youtube', label: 'YouTube', color: '#FF0000' },
    { key: 'facebook_url', brand: 'facebook', label: 'Facebook', color: '#1877F2' },
    { key: 'telegram_url', brand: 'telegram', label: 'Telegram', color: '#26A5E4' },
    { key: 'twitter_url', brand: 'twitter', label: 'X', color: '#ffffff' },
    { key: 'tiktok_url', brand: 'tiktok', label: 'TikTok', color: '#ffffff' },
    { key: 'linkedin_url', brand: 'linkedin', label: 'LinkedIn', color: '#0A66C2' },
    { key: 'messenger_url', brand: 'messenger', label: 'Messenger', color: '#0084FF' },
];

export function normalizePhoneDigits(phone) {
    if (!phone) {
        return '';
    }
    return String(phone).replace(/\D/g, '');
}

export function buildWhatsappHref(appData) {
    if (!appData) {
        return null;
    }

    if (appData.whatsapp_url) {
        return appData.whatsapp_url;
    }

    const digits = normalizePhoneDigits(appData.contact_phone);
    if (!digits) {
        return null;
    }

    return `https://wa.me/${digits}`;
}

export function buildWhatsappContact(appData) {
    const href = buildWhatsappHref(appData);
    if (!href) {
        return null;
    }

    const phone = appData.contact_phone || appData.whatsapp_phone || null;
    const urlDigits = href.match(/wa\.me\/(\d+)/i)?.[1] || '';
    const displayPhone = phone || (urlDigits ? `+${urlDigits}` : null);

    return {
        brand: 'whatsapp',
        label: 'WhatsApp',
        color: '#25D366',
        href,
        displayPhone,
    };
}

export function buildFooterSocialItems(appData) {
    if (!appData) {
        return [];
    }

    return SOCIAL_FIELDS.reduce((items, field) => {
        const href = appData[field.key];
        if (href) {
            items.push({
                brand: field.brand,
                label: field.label,
                color: field.color,
                href,
            });
        }
        return items;
    }, []);
}

export function getFooterCredits(appData, welcomeData) {
    const source = appData || welcomeData || {};
    return source.credits || source.footer_credits || source.footer_credit || null;
}

export function getFooterDescription(appData) {
    if (!appData) {
        return null;
    }

    return appData.app_description || appData.description || appData.about_text || null;
}
